
import { Vue } from 'vue-class-component'
import liff from '@line/liff'
import { addGAEvent } from '@/helpers/addGoogleAnalytic'

export default class Unlink extends Vue {
  backToLine() {
    addGAEvent({
      event: 'back_to_line'
    })
    liff.closeWindow()
  }
}
